import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { countryList, s3Static } from '../../../utils/constants'
import { contentDate, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { airconCostCalculation } from '../../../js/aircon-cost'
import { BsArrowRightCircle } from 'react-icons/bs'
import { AirconQuickLinks } from '../../../components/index/service-category/aircon-service/AirconQuickLinks'
import { AcServiceLocality } from '../../../components/index/service-category/aircon-service/AcServiceLocality'
import { RequestProvider } from 'context/RequestContext'
import AirconRequestSection from '@/index/service-category/aircon-service/AirconRequestSection'
import { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import { AirconScope } from '@/index/service-category/aircon-service/AirconScope'
import { AirconGeneralServiceProcess } from '@/index/service-category/aircon-service/AirconGeneralServiceProcess'
import { AirconBrandsWeSupport } from '@/index/service-category/aircon-service/AirconBrandsWeSupport'
import { AirconWhyUs } from '@/index/service-category/aircon-service/AirconWhyUs'
import { buildAirconServiceGraph } from 'utils/aircon-page-schema'


// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-10-23'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")
    
    const { month, year } = contentDate(CONTENT_REVIEWED)
    const modifiedDate = reviewedIso(CONTENT_REVIEWED)
    const airconBlogs = blogsMaster['hvac-services'].blogArray

    let standardServicing = []
    let annualServicing = []
    let chemicalServicing = []
    let overhaulServicing = []    
    const currencyCd = "SGD"

    airconCostCalculation(currencyCd, annualServicing, standardServicing, chemicalServicing, overhaulServicing)

    const getLocalityList = () => {
        for(let x in countryList){
            if(countryList[x].country_name === countryName){
                return countryList[x].localityList
            }
        }
    } 

    const localityList = getLocalityList()

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        annualServicing,
        localityList,
        standardServicing,
        annualServicing,
        chemicalServicing,
        overhaulServicing,
        currencyCd,
        countryName
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings
    const standardServicing = props.standardServicing
    const annualServicing = props.annualServicing
    const chemicalServicing = props.chemicalServicing
    const overhaulServicing = props.overhaulServicing
    const localityList = props.localityList
    const currencyCd = props.currencyCd
    const requestType = 'Aircon Services'
    const countryName = props.countryName

    const [ requestForm, setRequestForm ] = useState(false)    
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isCustomBook, setIsCustomBook ] = useState(false)

    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ serviceType, setServiceType ] = useState("general")
    const [ unit, setUnit ] = useState("")
    const [ unitType, setUnitType ] = useState("")
    const [ cost, setCost ] = useState("")
   
  return (
    <>
      <Head>
        <title>Aircon Servicing Annual Package for Tenants & Home Owners</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="StringsSG offers the most affordable annual packages for aircon servicing which is a great option if you need regular aircon servicing in Singapore."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/annual-package" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Aircon Servicing Annual Package for Tenants & Home Owners | StringsSG`}/>
        <meta property="og:description" content="Aircon Servicing of 3 units for a one-time servicing can cost between $70 to $100, depending on the service provider." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-29T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/aircon-service.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/aircon-service.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/annual-package"/>
        <meta name="twitter:title" content={`Aircon Servicing Annual Package for Tenants & Home Owners | StringsSG`}/> 
        <meta name="twitter:description" content="StringsSG offers the most affordable annual packages for aircon servicing which is a great option if you need regular aircon servicing in Singapore."/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(buildAirconServiceGraph({
            path: '/sg/aircon-servicing-singapore/annual-package',
            pageName: 'Aircon Servicing Annual Package for Tenants & Home Owners',
            description: 'StringsSG offers the most affordable annual packages for aircon servicing which is a great option if you need regular aircon servicing in Singapore.',
            serviceName: 'Aircon Servicing Annual Package',
            serviceType: 'Aircon Servicing',
            image: 'https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/aircon-service.jpg',
            datePublished: '2025-01-29T07:30:46+00:00',
            modifiedDate,
            breadcrumbName: 'Annual Package',
          })) }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/annual-package"/>
        </Head>
        <div>
            <RequestProvider>
                <AirconRequestSection
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    setIsQuickBook={setIsQuickBook}
                    isCustomBook={isCustomBook}
                    setIsCustomBook={setIsCustomBook}
                    requestCategorySettings={requestCategorySettings}
                    standardServicing={standardServicing}
                    chemicalServicing={chemicalServicing}
                    overhaulServicing={overhaulServicing}
                    currencyCd={currencyCd}
                    countryName={countryName}
                    requestType={requestType}
                    setIsShowJobScope={setIsShowJobScope}
                    serviceType={serviceType}
                    setServiceType={setServiceType}
                    setUnit={setUnit}
                    setUnitType={setUnitType}
                    setCost={setCost}
                    heroImage="aircon-service.jpg"
                    title="Aircon Servicing Annual Package"
                />
            </RequestProvider>
            <section className="max-w-5xl mx-auto py-6 md:py-12 px-4 md:px-6 space-y-5 md:space-y-10">
                <div id="annual-package" className="space-y-4 md:space-y-8">
                    <p className="text-center text-base text-gray-700 max-w-2xl mx-auto leading-8">
                        Save more with StringsSG&apos;s affordable and reliable annual aircon servicing plans — perfect for homes and offices in Singapore that require regular maintenance. 
                        Enjoy peace of mind, improved cooling performance, and cost-efficiency all year round.
                    </p>
                    {/* Highlight Note */}
                    <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 rounded-md max-w-3xl mx-auto text-lg">
                        <strong>Note:</strong> Book <em>Annual Package</em> under the <strong>&quot;More Options&quot;</strong> button in the booking form above.
                    </div>
                    <section aria-label="Benefits of Annual Aircon Service Packages" className="grid gap-3 md:gap-6 sm:grid-cols-2">
                    {[
                        {
                        title: 'Cost-Effective Savings',
                        bg: 'bg-slate-100',
                        content:
                            'Annual packages are significantly more affordable than one-time services. Enjoy discounted rates and predictable costs for regular aircon maintenance.',
                        },
                        {
                        title: 'Full-Service Maintenance',
                        content:
                            'Packages include deep cleaning, gas top-ups, filter washing, and system diagnostics to keep your aircon running efficiently and extend its lifespan.',
                        },
                        {
                        title: 'Smart Scheduling',
                        bg: 'bg-slate-100',
                        content:
                            'Never miss a service again — our platform auto-schedules your sessions based on your plan. You can reschedule anytime via your dashboard.',
                        },
                        {
                        title: 'Seamless Management',
                        content:
                            'Manage all your service details in one place. Chat with technicians, track visits, and handle package renewals conveniently on our platform.',
                        },
                        {
                        title: 'Trusted Technicians',
                        bg: 'bg-slate-100',
                        content:
                            'All services are performed by vetted technicians from licensed aircon contractors in Singapore. Fast, reliable, and quality guaranteed.',
                        },
                        {
                        title: 'Flexible Plans',
                        content:
                            'Choose from 2, 3, or 4 services per year based on your cooling needs and budget. Ideal for both HDBs and private properties.',
                        },
                    ].map(({ title, content, bg }, idx) => (
                        <article key={idx} className={`p-5 rounded-lg shadow-sm space-y-3 ${bg || 'bg-white'}`}>
                        <h3 className="text-lg font-semibold text-center uppercase tracking-wide text-gray-800">
                            {title}
                        </h3>
                        <p className="text-sm text-gray-700 leading-relaxed">{content}</p>
                        </article>
                    ))}
                    </section>
                </div>
            </section>  
            <section className="my-6 md:my-14 max-w-5xl mx-auto px-4 space-y-4 md:space-y-8">
                <h2 className="text-2xl md:text-3xl font-bold text-center">
                    Aircon Servicing Annual Package Price in Singapore
                </h2>

                <div className="flex justify-center overflow-x-auto">
                    <table className="w-full sm:w-5/6 border text-sm text-center">
                    <thead className="bg-amber-50 text-orange-600 uppercase">
                        <tr>
                        <th className="p-3 border">No. of Aircons (Wall Mount)</th>
                        <th className="p-3 border">4 times/year</th>
                        <th className="p-3 border">3 times/year</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {annualServicing.map((tran, i) => (
                        <tr key={i} className="even:bg-slate-50">
                            <td className="p-3 border">{tran.number}</td>
                            <td className="p-3 border">{tran.threeMonthInterval}</td>
                            <td className="p-3 border">{tran.fourMonthInterval}</td>
                        </tr>
                        ))}
                        <tr className="bg-yellow-50 font-medium">
                        <td className="p-3 border">More than 5</td>
                        <td className="p-3 border" colSpan={2}>
                            Open request for pricing
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </section>
            <section className="bg-amber-50 py-6 md:py-14 px-4">
                <div className="max-w-5xl mx-auto space-y-5 md:space-y-10">
                    <header className="text-center space-y-4">
                    <h2 className="text-2xl md:text-3xl font-bold">
                        Exclusive Features for Annual Aircon Package Clients
                    </h2>
                    <p className="text-base text-gray-700 max-w-2xl mx-auto">
                        StringsSG provides a premium digital experience for clients with an annual aircon servicing package. Get total control, convenience, and responsive support through our platform.
                    </p>
                    </header>

                    <div className="grid md:grid-cols-2 gap-3 md:gap-6 text-sm md:text-base text-gray-800">
                    {[
                        {
                        icon: <BsArrowRightCircle className="text-orange-600 text-xl" />,
                        text: "Flexibility to reschedule your aircon servicing dates directly from your dashboard.",
                        },
                        {
                        icon: <BsArrowRightCircle className="text-orange-600 text-xl" />,
                        text: "Easily track and manage all upcoming or pending services through your account.",
                        },
                        {
                        icon: <BsArrowRightCircle className="text-orange-600 text-xl" />,
                        text: "Download PDF service records after every session — perfect for tenancy agreement proof.",
                        },
                        {
                        icon: <BsArrowRightCircle className="text-orange-600 text-xl" />,
                        text: 'Access your contract anytime under the "My Packages" section on the platform.',
                        },
                        {
                        icon: <BsArrowRightCircle className="text-orange-600 text-xl" />,
                        text: "Report issues directly to the service team using the in-app chat feature.",
                        },
                        {
                        icon: <BsArrowRightCircle className="text-orange-600 text-xl" />,
                        text: "24/7 WhatsApp support — get assistance anytime, even outside regular hours.",
                        },
                    ].map(({ icon, text }, i) => (
                        <div key={i} className="flex items-start space-x-3 bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition">
                        <span className="mt-1">{icon}</span>
                        <p>{text}</p>
                        </div>
                    ))}
                    </div>
                </div>
            </section>
             
            <section id="service-agreement" className="py-6 md:py-14 px-4 bg-gray-50">
                <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">
                    Aircon Service Agreement & Service Records
                </h2>

                <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-center">
                    <div className="space-y-6 text-gray-800 leading-relaxed">
                    <div className="flex items-start space-x-4">
                        <span className="text-2xl text-orange-600 mt-1"><BsArrowRightCircle /></span>
                        <p>
                        Receive a professionally generated <strong>PDF service agreement</strong> when you subscribe to any annual aircon package.
                        </p>
                    </div>
                    <div className="flex items-start space-x-4">
                        <span className="text-2xl text-orange-600 mt-1"><BsArrowRightCircle /></span>
                        <p>
                        Access your <strong>digital service receipts and invoices</strong> anytime via the StringsSG platform — for both one-time and package bookings.
                        </p>
                    </div>
                    <div className="flex items-start space-x-4">
                        <span className="text-2xl text-orange-600 mt-1"><BsArrowRightCircle /></span>
                        <p>
                        Useful for tenants: Easily download <strong>proof of aircon maintenance</strong> in PDF format for lease documentation or landlord requirements.
                        </p>
                    </div>
                    </div>

                    <div className="relative h-96 hidden md:block">
                    <Image
                        src={s3Static + "blog/living/Fashionable-Women-PNG.png"}
                        alt="StringsSG Aircon Service Provider Communication"
                        fill
                        priority={false}
                        style={{ objectFit: "cover", objectPosition: "top" }}
                    />
                    </div>
                </div>
            </section>

            {/* Mobile fold budget: these two sample documents were hardcoded to 680px each
                (1,528px of the page on a phone) for images that are illustrative only. They
                are now 2-up at a readable 240px on mobile and keep the full 680px at md+. */}
            <section className="p-3 md:p-6 grid grid-cols-2 md:grid-cols-2 gap-3 md:gap-8 bg-white">
                <div className="text-center space-y-2 md:space-y-4">
                    <h3 className="text-sm md:text-xl font-semibold">Sample Service Agreement</h3>
                    <div className="relative w-full h-60 md:h-170">
                    <Image
                        src={s3Static + "sample-service-agreement-new.jpg"}
                        alt="Sample Aircon Service Agreement PDF"
                        fill
                        style={{ objectFit: "contain", objectPosition: "top" }}
                        priority={false}
                        sizes='(max-width: 768px) 50vw, 33vw'
                    />
                    </div>
                </div>

                <div className="text-center space-y-2 md:space-y-4">
                    <h3 className="text-sm md:text-xl font-semibold">Sample Service Record</h3>
                    <div className="relative w-full h-60 md:h-170">
                    <Image
                        src={s3Static + "service-record-sample.jpg"}
                        alt="Sample Aircon Servicing Record PDF"
                        fill
                        style={{ objectFit: "contain", objectPosition: "top" }}
                        priority={false}
                        sizes='(max-width: 768px) 50vw, 33vw'
                    />
                    </div>
                </div>
            </section>
            <section className='max-w-5xl mx-auto py-5 md:py-10'>
                <AirconGeneralServiceProcess />
            </section>
            <AirconWhyUs/>
            <AirconBrandsWeSupport/>
            {/* <AcServiceLocality localityList={localityList}/> */}
            <BlogsList blogs={airconBlogs}/> 
            {/* <AirconQuickLinks/> */}
        </div>
        {isShowJobScope &&
            <AnimatePresence>
               <AirconScope 
                setIsShowJobScope={setIsShowJobScope}
                serviceType={serviceType} 
                unit={unit} 
                unitType={unitType} 
                cost={cost} />
            </AnimatePresence>
        }
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '128634041116395');
            fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
